import React from "react";
import CreditNotes from "./CreditNoteLists/CreditNotes";

const PendingForFinanceDirectorApproval = () => {
    return <CreditNotes status="finance-director" title="pending" link="finance-director-credit-notes"/>;
};

export default PendingForFinanceDirectorApproval;
